// module imports
// import $ from "jquery";

document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
  } else {
    console.error("GSAP ist nicht geladen!");
  }
});

// Hamburger Toggle
document.addEventListener("DOMContentLoaded", function () {
  // Elements
  const hamburgerButtons = document.querySelectorAll("#hamburger");
  const desktopNav = document.querySelector(".desktopnav");
  const mobileNav = document.querySelector(".mobilenav");
  const body = document.body;

  // Check if we're on mobile or desktop
  function isMobile() {
    return window.innerWidth < 768; // md breakpoint
  }

  // Toggle navigation
  function toggleNavigation() {
    if (isMobile()) {
      // Mobile Navigation
      mobileNav.classList.toggle("active");
      hamburgerButtons.forEach((btn) => btn.classList.toggle("is-active"));

      // Prevent body scroll when mobile menu is open
      if (mobileNav.classList.contains("active")) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
      }
    } else {
      // Desktop Navigation
      desktopNav.classList.toggle("active");
      hamburgerButtons.forEach((btn) => btn.classList.toggle("is-active"));

      // Prevent body scroll when desktop menu is open
      if (desktopNav.classList.contains("active")) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
      }
    }
  }

  // Close navigation
  function closeNavigation() {
    desktopNav.classList.remove("active");
    mobileNav.classList.remove("active");
    hamburgerButtons.forEach((btn) => btn.classList.remove("is-active"));
    body.style.overflow = "";
  }

  // Event Listeners
  hamburgerButtons.forEach((button) => {
    button.addEventListener("click", toggleNavigation);
  });

  // Close on escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeNavigation();
    }
  });

  // Close on window resize if switching between mobile/desktop
  window.addEventListener("resize", function () {
    if (isMobile() && desktopNav.classList.contains("active")) {
      closeNavigation();
    } else if (!isMobile() && mobileNav.classList.contains("active")) {
      closeNavigation();
    }
  });

  // Close when clicking outside
  document.addEventListener("click", function (e) {
    const isHamburger = e.target.closest("#hamburger");
    const isNav = e.target.closest(".desktopnav, .mobilenav");

    if (!isHamburger && !isNav) {
      closeNavigation();
    }
  });
  // Beim Laden prüfen ob Overlay-Scrollbar oder klassische Scrollbar verwendet wird
  function checkScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      // Klassischer Scrollbar vorhanden
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    } else {
      // Overlay Scrollbar
      document.documentElement.style.setProperty("--scrollbar-width", "0px");
    }
  }
  checkScrollbarWidth();
  window.addEventListener("resize", checkScrollbarWidth);

  checkScrollbarWidth();
  console.log(
    "Scrollbar width:",
    getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width"),
  );

  // Get the button:
  let mybutton = document.getElementById("topBtn");

  // When the user scrolls down 20px from the top of the document, show the button
  window.addEventListener("scroll", scrollFunction);

  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    gsap.to([document.body, document.documentElement], {
      duration: 1,
      scrollTop: 0,
      ease: "power2.out",
    });
  }

  mybutton.addEventListener("click", topFunction);
});

// Ninja Forms Textarea Auto-Resize
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function () {
    document.querySelectorAll("textarea").forEach((textarea) => {
      if (textarea.dataset.autoResize) return; // Bereits setup

      textarea.dataset.autoResize = "true";
      textarea.style.setProperty("height", "30px", "important");
      textarea.style.setProperty("min-height", "30px", "important");
      textarea.style.resize = "none";
      textarea.style.overflow = "hidden";

      textarea.addEventListener("input", function () {
        this.style.setProperty("height", "30px", "important");
        this.style.setProperty("height", this.scrollHeight + "px", "important");
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial run
  observer.disconnect();
  observer.observe(document.body, { childList: true, subtree: true });
});

// GSAP Logo Animation
document.addEventListener("DOMContentLoaded", function () {
  // Funktion für Header-Animation (sofort nach Page Load)
  function animateHeaderLogo() {
    const headerLogo = document.querySelector("header svg");
    if (!headerLogo) return;

    // Timeline für Header erstellen
    const headerTimeline = gsap.timeline();

    // Initial Setup - Startzustand definieren
    headerTimeline
      .set([".first-animation", ".second-animation", ".third-animation", ".fourth-animation"], {
        scale: 1.3,
        opacity: 0,
        transformOrigin: "center",
      })
      .set(".fifth-animation", {
        x: -13,
        opacity: 0,
      })

      // Animation-Sequenz (von set zu to)
      .to(
        ".first-animation",
        {
          scale: 1,
          opacity: 1,
          duration: 0.2,
          ease: "power2.out",
        },
        0.1,
      ) // Start bei 0.1s

      .to(
        ".second-animation",
        {
          scale: 1,
          opacity: 1,
          duration: 0.2,
          ease: "power2.out",
        },
        0.2,
      ) // Start bei 0.2s

      .to(
        ".third-animation",
        {
          scale: 1,
          opacity: 1,
          duration: 0.2,
          ease: "power2.out",
        },
        0.3,
      ) // Start bei 0.3s

      .to(
        ".fourth-animation",
        {
          scale: 1,
          opacity: 1,
          duration: 0.2,
          ease: "power2.out",
        },
        0.4,
      ) // Start bei 0.4s

      .to(
        ".fifth-animation",
        {
          x: -10,
          opacity: 0.5,
          duration: 0.1,
          ease: "power2.out",
        },
        0.8,
      ) // Start bei 0.8s

      .to(
        ".fifth-animation",
        {
          x: 0,
          opacity: 1,
          duration: 0.2,
          ease: "power2.out",
        },
        0.9, // Start bei 0.9s
      );

    // Timeline starten
    headerTimeline.play();
  }

  // Funktion für Footer-Animation
  function setupFooterAnimation() {
    const footerLogo = document.querySelector("footer svg");
    if (!footerLogo) return;

    // IntersectionObserver für Footer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer Timeline erstellen
            const footerTimeline = gsap.timeline();

            // Initial Setup für Footer - Startzustand
            footerTimeline
              .set(
                [
                  ".first-animation-footer",
                  ".second-animation-footer",
                  ".third-animation-footer",
                  ".fourth-animation-footer",
                ],
                {
                  scale: 1.3,
                  opacity: 0,
                  transformOrigin: "center",
                },
              )
              .set(".fifth-animation-footer", {
                x: -13,
                opacity: 0,
              })
              // Animation-Sequenz
              .to(
                ".first-animation-footer",
                {
                  scale: 1,
                  opacity: 1,
                  duration: 0.2,
                  ease: "power2.out",
                },
                0.1,
              ) // Start bei 0.1s

              .to(
                ".second-animation-footer",
                {
                  scale: 1,
                  opacity: 1,
                  duration: 0.2,
                  ease: "power2.out",
                },
                0.2,
              ) // Start bei 0.2s

              .to(
                ".third-animation-footer",
                {
                  scale: 1,
                  opacity: 1,
                  duration: 0.2,
                  ease: "power2.out",
                },
                0.3,
              ) // Start bei 0.3s

              .to(
                ".fourth-animation-footer",
                {
                  scale: 1,
                  opacity: 1,
                  duration: 0.2,
                  ease: "power2.out",
                },
                0.4,
              ) // Start bei 0.4s

              .to(
                ".fifth-animation-footer",
                {
                  x: -10,
                  opacity: 0.5,
                  duration: 0.1,
                  ease: "power2.out",
                },
                0.8,
              ) // Start bei 0.8s

              .to(
                ".fifth-animation-footer",
                {
                  x: 0,
                  opacity: 1,
                  duration: 0.2,
                  ease: "power2.out",
                },
                0.9, // Start bei 0.9s
              );

            // Timeline starten
            footerTimeline.play();

            // Observer stoppen nach Animation
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: "50px",
      },
    );

    observer.observe(footerLogo);
  }

  // Page Load Detection
  function onPageFullyLoaded() {
    // Header Animation starten
    animateHeaderLogo();

    // Footer Observer setup
    setupFooterAnimation();
  }

  // Load States abfangen
  if (document.readyState === "complete") {
    onPageFullyLoaded();
  } else {
    window.addEventListener("load", onPageFullyLoaded);
  }
  // GSAP ScrollTrigger Animationen
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    // SCROLLANIM Animation
    document.querySelectorAll(".scrollanim").forEach((el) => {
      gsap.fromTo(
        el,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top bottom-=100",
            toggleActions: "play none none reverse",
          },
        },
      );
    });

    // SCROLL-TRIGGER Span Animation
    gsap.utils.toArray(".scroll-trigger").forEach((container) => {
      const spans = container.querySelectorAll("span");

      if (spans.length > 0) {
        gsap.set(spans, { opacity: 0 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start: "top 90%",
            end: "bottom 70%",
            scrub: 1,
            refreshPriority: -1,
          },
        });

        tl.to(spans, {
          opacity: 1,
          duration: 1,
          stagger: 0.3,
          ease: "none",
        });
      }
    });
  }
});

// Akkordeon (vereinheitlicht mit Auto-Scroll)
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordeon-item");

  if (!items || items.length === 0) return;

  let activeAccordion = null;

  // Funktion zum Setzen der minHeight
  function setMinHeight() {
    items.forEach((item) => {
      item.style.minHeight = window.innerWidth < 768 ? "50px" : "60px";
    });
  }

  // Initial setzen
  setMinHeight();

  // Bei Resize setzen
  window.addEventListener("resize", setMinHeight);

  items.forEach((item) => {
    const header = item.querySelector(".accordeon-titel");
    const content = item.querySelector(".accordeon-content");
    const icon = item.querySelector(".accordeon-icon"); // Icon für Rotation

    if (!header || !content) return;

    // Anfangszustand: alle geschlossen
    content.style.maxHeight = "0px";
    content.style.opacity = "0";
    item.classList.remove("aktiv");
    content.classList.remove("active");

    // Container-Höhe auf auto setzen für dynamische Anpassung
    item.style.height = "auto";

    // A11y: aria-expanded setzen
    header.setAttribute("aria-expanded", "false");
    header.style.cursor = "pointer";

    header.addEventListener("click", function () {
      const isOpen = content.classList.contains("active");
      const wasAnotherOpen = activeAccordion && activeAccordion !== content;
      const clickedHeader = this;

      if (isOpen) {
        // Akkordeon schliessen - kein Auto-Scroll
        item.classList.remove("aktiv");
        content.classList.remove("active");
        content.style.maxHeight = "0px";
        content.style.opacity = "0";
        header.setAttribute("aria-expanded", "false");
        if (icon) icon.style.transform = "rotate(0deg)";
        activeAccordion = null;
      } else {
        // 1. Alle anderen Akkordeons schließen
        items.forEach((otherItem) => {
          const otherContent = otherItem.querySelector(".accordeon-content");
          const otherHeader = otherItem.querySelector(".accordeon-titel");
          const otherIcon = otherItem.querySelector(".accordeon-icon");

          if (otherItem !== item) {
            otherItem.classList.remove("aktiv");
            otherContent.classList.remove("active");
            otherContent.style.maxHeight = "0px";
            otherContent.style.opacity = "0";
            if (otherHeader) otherHeader.setAttribute("aria-expanded", "false");
            if (otherIcon) otherIcon.style.transform = "rotate(0deg)";
          }
        });

        const scrollDelay = wasAnotherOpen ? 300 : 50;

        setTimeout(() => {
          // Zum Header scrollen
          const headerPosition = clickedHeader.getBoundingClientRect().top + window.pageYOffset;
          const viewportHeight = window.innerHeight;
          const offsetPosition =
            headerPosition - viewportHeight / 2 + clickedHeader.offsetHeight / 2;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });

          // Nach dem Scroll das Akkordeon öffnen
          setTimeout(() => {
            item.classList.add("aktiv");
            content.classList.add("active");
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
            header.setAttribute("aria-expanded", "true");
            if (icon) icon.style.transform = "rotate(135deg)";
            activeAccordion = content;
          }, 300);
        }, scrollDelay);
      }
    });
  });
});
